import React from 'react';
import {  Responsive,SimpleList,NumberField,DateField,Show,ShowButton,List, Datagrid,TextField, SimpleShowLayout,ReferenceInput,Filter,SelectInput,FunctionField }
from 'admin-on-rest/lib/mui';
var minDate=new Date();
minDate.setDate(minDate.getDate()-180);

const HafkadotRicuzYomiFilter = (props) => (
    <Filter {...props}>
       
         <ReferenceInput label="בית עסק" source="id" reference="customers" allowEmpty>
            <SelectInput optionText="name_heb" />
        </ReferenceInput>

    </Filter>
);

const rowStyle = (record) => {
    if (record.commission_ammount <0) return { backgroundColor: '#fdd' };
    
    return {};
};

export const HafkadotRicuzYomiList = (props) => (
    <List title="דף חשבון" perPage={30} {...props}  filters={<HafkadotRicuzYomiFilter /> }>
      <Responsive
       small={
                <SimpleList
                    primaryText={record =>"תאריך הפקדה"+ new Date(record.deposit_date.date).toLocaleDateString()}
                    secondaryText={record =>"סוג עסקה"+ record.tnuaa_type}
                    tertiaryText={record =>"מספר ריכוז"+ record.rikuz_number}
                   
                    
                />
            }
 medium={

          <Datagrid  rowStyle={rowStyle} bodyOptions={{showRowHover: true }}>
            
<TextField label="#" source="id" />

<DateField label="תאריך הפקדה" source="deposit_date.date" locales="he-IL"/>
<DateField label="תאריך עסקה" source="rchisha_date.date" locales="he-IL"/>
<DateField label="תאריך זיכוי" source="zikui_date.date" locales="he-IL" />
<TextField label="סוג עסקה" source="tnuaa_type" />


<NumberField label="סכום עסקה" source="schum_iska" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }} />
<NumberField label="סכום ברוטו לזיכוי" locales="he-IL" source="zikui_total_bruto" options={{ style: 'currency', currency: 'ILS' }}/>

<NumberField label="עמלה" style={{overflow:'visible '}} source="commission_ammount" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }}/>
<NumberField label="עמלה + מעמ"  style={{overflow:'visible '}} source="commission_ammount_vat" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }} />
<NumberField label="סכום נטו לזיכוי" style={{overflow:'visible '}} source="neto_zicui" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }}/>

<TextField label="מספר ריכוז" source="rikuz_number" />
<TextField label="כ.א 4 ספרות" source="cc_id" />

    

    
            <ShowButton />
        </Datagrid>
 }
         />
    </List>
);


const HafkadotRicuzYomiTitle = ({ record }) => {
    return <span>מספר {record ? `"${record.id}"` : ''}</span>;
};













const HafkadotRicuzYomiStyle = {
  width:120,
    minHeight: 40,
    marginLeft: '2em',
    display: 'inline-block',
    verticalAlign: 'top'
};



export const HafkadotRicuzYomiShow = (props) => (

<Show title={<HafkadotRicuzYomiTitle />} {...props}>
 <SimpleShowLayout >
  <TextField style={HafkadotRicuzYomiStyle}  label="#" source="id" />
<TextField style={HafkadotRicuzYomiStyle}  label="מזהה רשת חיצוני" source="external_id" />

<TextField style={HafkadotRicuzYomiStyle} label="מספר בית עסק" source="buisiness_id" />
<TextField style={HafkadotRicuzYomiStyle} label="מספר כרטיס מלא" source="cc_id" />

<TextField style={HafkadotRicuzYomiStyle}  elStyle={{ width: '5em' }} label="מספר שובר" source="shovar_number" />
<TextField style={HafkadotRicuzYomiStyle} label="סוג תנועה" source="tnuaa_type" />
<TextField style={HafkadotRicuzYomiStyle} label="מקור  תנועה" source="tnuaa_source" />
<DateField style={HafkadotRicuzYomiStyle} label="תאריך הפקדה" source="deposit_date.date" />
<DateField style={HafkadotRicuzYomiStyle} label="תאריך זיכוי" source="zikui_date.date" />
<TextField style={HafkadotRicuzYomiStyle} label="מספר חשבון" source="account_number" />
<TextField style={HafkadotRicuzYomiStyle} label="מטבע תנועה" source="tnuaa_currency" />
<TextField style={HafkadotRicuzYomiStyle} label="מטבע זיכוי" source="zikui_currency" />
<TextField style={HafkadotRicuzYomiStyle} label="אינדיקציה לתשלומים" source="payments_indication" />
<TextField style={HafkadotRicuzYomiStyle} label="סכום עסקה  ברוטו תשלומים" source="bruto_iska_tashlumim" />
<TextField style={HafkadotRicuzYomiStyle} label="סכום ברוטו לזיכוי " source="zikui_total_bruto" />
<TextField style={HafkadotRicuzYomiStyle} label="סכום עמלה" source="commission_ammount" />
<TextField style={HafkadotRicuzYomiStyle} label="מעמ עמלה" source="comission_vat" />
<TextField style={HafkadotRicuzYomiStyle} label="סכום ההנחה" source="discount_ammount" />
<TextField style={HafkadotRicuzYomiStyle} label="סכום זיכוי" source="total_zikui" />
<TextField style={HafkadotRicuzYomiStyle} label="מספר תשלום נוכחי" source="current_payment_number" />
<TextField style={HafkadotRicuzYomiStyle} label="מספר תשלומים" source="total_payments" />
<TextField style={HafkadotRicuzYomiStyle} label="יתרת תשלומים" source="remaining_payments" />
<TextField style={HafkadotRicuzYomiStyle} label="סכום ריבית דמי ניכיון" source="total_dme_nikayon_interest" />
<TextField style={HafkadotRicuzYomiStyle} label="סכום דמי ניהול " source="total_dme_nihul" />
<TextField style={HafkadotRicuzYomiStyle} label="ניקוד ב- pos" source="pos_points" />

<TextField style={HafkadotRicuzYomiStyle} label="מספר מסוף" source="masof_number" />
<TextField style={HafkadotRicuzYomiStyle} label="תש' ראשון" source="first_payment" />
<TextField style={HafkadotRicuzYomiStyle} label="סכום תשלום" source="total_ammount" />
<TextField style={HafkadotRicuzYomiStyle} label="מועדון" source="club" />

<TextField style={HafkadotRicuzYomiStyle} label="קוד אישור" source="kod_ishur" />
<TextField style={HafkadotRicuzYomiStyle} label="קוד מאפיין  עסקה" source="kod_meafyen_iska" />
<TextField style={HafkadotRicuzYomiStyle} label="קוד אופי עסקה" source="kod_ofi_iska" />
<TextField style={HafkadotRicuzYomiStyle} label="מזהה חד ערכי" source="unique_id" />
<TextField style={HafkadotRicuzYomiStyle} label="סכום ביטול" source="bitul_ammount" />
<TextField style={HafkadotRicuzYomiStyle} label="סכום עצירה" source="stop_ammount" />
<TextField style={HafkadotRicuzYomiStyle} label="מזהה תנועה" source="tnuaa_id" />
<TextField style={HafkadotRicuzYomiStyle} label="מהות עסקה" source="mahut_iska" />
<TextField style={HafkadotRicuzYomiStyle} label="שער המרה" source="shaar_hamara" />
<TextField style={HafkadotRicuzYomiStyle} label="שדה Z" source="z_field" />
<TextField style={HafkadotRicuzYomiStyle} label="מזדמנת כ/ל" source="mizdamenet" />
<TextField style={HafkadotRicuzYomiStyle} label="סטטוס רשומה 1/2" source="status_reshuma" />
<TextField style={HafkadotRicuzYomiStyle} label="שם בית עסק" source="shem_esek" />
<TextField style={HafkadotRicuzYomiStyle} label="מספר חשבון" source="mispar_cheshbon" />
<TextField style={HafkadotRicuzYomiStyle} label="מזהה תוכנית כאל לקבל יותר" source="mezahe_tochnit_cal_yoter" />
<TextField style={HafkadotRicuzYomiStyle} label="סכום הנחת כאל לקבל יותר" source="hanacha_cal_yoter" />
<TextField style={HafkadotRicuzYomiStyle} label="אחוז הנחת כאל לקבל יותר" source="ahuz_hanacha_cal_yoter" />
<TextField style={HafkadotRicuzYomiStyle} label="Mid Trn ID" source="mid_trn_id" />
<TextField style={HafkadotRicuzYomiStyle} label="PSP Trn ID" source="psp_trn_id" />
<TextField style={HafkadotRicuzYomiStyle} label="Gateway Trn ID" source="gateway_trn_id" />
<TextField style={HafkadotRicuzYomiStyle} label="מזהה בקשת אישור" source="mezahe_bakasha_ishur" />

<TextField style={HafkadotRicuzYomiStyle} label="מספר חשבונית" source="mispar_cheshbonit" />
<TextField style={HafkadotRicuzYomiStyle} label="מספר משלם" source="mispar_meshalem" />
<TextField style={HafkadotRicuzYomiStyle} label="סוג תנועה שבא" source="sug_tnuaa_shva" />
<TextField style={HafkadotRicuzYomiStyle} label="סכום מזומן CASHBACK" source="mezuman_schum_cashback" />
<TextField style={HafkadotRicuzYomiStyle} label="מזהה עסקה שבא" source="mezahe_iska_shva" />
<TextField style={HafkadotRicuzYomiStyle} label="אינדיקציה לתייר" source="tayar_indikazia" />
<TextField style={HafkadotRicuzYomiStyle} label="קובץ מקור" source="source_file" />

         </SimpleShowLayout>
    </Show>
);





// WEBPACK FOOTER //
// ./src/components/Hafkadot/hafkadot_ricuz_yomi.js